import React,{ useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Notice from "../../partials/content/Notice";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import { getPendingApprovals,approvePending,rejectPending,getAccounts,getAccountTypes } from "../../crud/auth.crud";

import CodeExample from "../../partials/content/CodeExample";
import { Table } from "react-bootstrap";
 import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import { TextField,MenuItem } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import 'date-fns';
import Grid from '@material-ui/core/Grid';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

class UserApproval extends React.Component {
  state = {
    users:[],
    status:false,
    statusMessage:'',
    open:false,
  }

constructor(props)
{
  super(props);
    this.state = {
      menu: false,
      users:[],
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      open:false,
      expiryDate:null
    };
    
  this.toggleMenu = this.toggleMenu.bind(this);
  //this.handleClick = this.handleClick.bind(this);
}
  
  

  toggleMenu(){
    this.setState({ menu: !this.state.menu })
  }

  componentDidMount()
  {
    
    getPendingApprovals().then(response => response.data)
    .then((data) => {
      this.setState({ users: data })
     //console.log(this.state.users)
     })

    getAccounts().then(response => response.data)
    .then((data) => {
      this.setState({ accounts: data })
     //console.log(this.state.users)
     })

    getAccountTypes().then(response => response.data)
    .then((data) => {
      this.setState({ accountTypes: data })
     //console.log(this.state.users)
     })
  }

  handleClick(user)
  {
    
      this.setState({user:user,open:true});
  
} 

approveUser=()=>
{
  const {intl}  = this.props ;
  let user = this.state.user;
      console.log('handleClickApprove');
      user.status="approved";
      user.isApproved=true;
      if(this.state.mappedAccounts!=null)
      {
        user.mappedAccounts = this.state.mappedAccounts;
      }
      //if(this.state.colorCode!=null)
      //{
        user.colorCode = '#'+Math.floor(Math.random()*16777215).toString(16);

      //}
      if(this.state.accountTypeKey!=null)
      {
        user.accountTypeKey = this.state.accountTypeKey;
      }
      if(this.state.expiryDate!=null)
      {
        user.expiryDate = this.state.expiryDate;
      }
      console.log("userdata",user);
      approvePending(user).then(response => response.data)
      .then((data) => {
        //this.setState({ users: data })
        //console.log(data);
        //this.setState({statusMessage: "The registration request has been approved",status:true});

        let usersList = this.state.users.filter((item) => {
                   return user.id !== item.id;
                });

          //      this.setState(state => {
          //          state.blogPosts = blogPosts;
          //          return state;
           //     });
           this.setState({users: usersList,alertType:'alert-success',status: true,open:false,statusMessage:
                      intl.formatMessage({
                        id: "REGISTRATION.APPROVAL.SUCCESS"
                      })
                    });

      })
      .catch(() => {
                    
                    this.setState({alertType:'alert-danger',status:true,statusMessage:
                      intl.formatMessage({
                        id: "REGISTRATION.APPROVAL.FAILURE"
                      })
                    });


                  });
                    
   


}

onSelectTag=(e, value)=> {

let tguser=[];
  if(value!=null)
  {
    value.map((acc)=>(
      tguser.push(acc.accountId)
      ))
    console.log(tguser);
    this.setState({mappedAccounts:tguser});
  }
}

handleClickReject(user)
  {
     const {intl}  = this.props ;
    
      console.log('handleClickReject');
      user.status="rejected";
      user.isApproved=false;
      
      rejectPending(user).then(response => response.data)
      .then((data) => {
        
           let usersList = this.state.users.filter((item) => {
                   return user.id !== item.id;
                });

        
           this.setState({users: usersList,alertType:'alert-success',status: true,statusMessage:
                      intl.formatMessage({
                        id: "REGISTRATION.REJECT.SUCCESS"
                      })
                    });

      })
      .catch(() => {
                    
                    this.setState({alertType:'alert-danger',status:true,statusMessage:
                      intl.formatMessage({
                        id: "REGISTRATION.REJECT.FAILURE"
                      })
                    });


                  });
       
  
} 

handleClickDetails(user)
  {
    return function(){
      console.log('handleClickDetails');
           
    }
 
  
} 

handleClose = () =>
  {
    this.setState({open:false});
  }


  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
    return (
      <>
        
        {status && (
          <div role="alert" className={"alert "+alertType}>
            <div className="alert-text">{statusMessage}</div>
          </div>
        )}

        {this.state.users.count === 0 &&
          (<Notice icon="flaticon-warning kt-font-primary">
            <p>
              The Box component serves as a wrapper component for most of the CSS
              utility needs.
            </p>
            <p>
              For more info please check the components's official{" "}
              <a
                target="_blank"
                className="kt-link"
                rel="noopener noreferrer"
                href="https://material-ui.com/components/box/"
              >
                demos & documentation
              </a>
            </p>
          </Notice>)

          }
  
        <div className="row">
         {this.state.users.map((user) => (

                <div className="col-xl-3" key={user.id} id={user.id}>
                  <div className="kt-portlet kt-portlet--height-fluid">
                    <div className="kt-portlet__head kt-portlet__head--noborder">
                      <div className="kt-portlet__head-label">
                        <h3 className="kt-portlet__head-title">
                        
                        </h3>
                      </div>
                      <div className="kt-portlet__head-toolbar">
                        <a  className="btn btn-icon" data-toggle="dropdown" onClick={ this.toggleMenu }>
                          <i className="flaticon-more-1 kt-font-brand"></i>
                        </a>
                        <div className={"dropdown-menu dropdown-menu-right "+ show}>
                          <ul className="kt-nav">
                            <li className="kt-nav__item">
                              <a  className="kt-nav__link" onClick = {()=>this.handleClickDetails(user)}>
                                <i className="kt-nav__link-icon flaticon2-line-chart"></i>
                                <span className="kt-nav__link-text">View</span>
                              </a>
                            </li>
                            <li className="kt-nav__item">
                              <a  className="kt-nav__link" onClick = {() => this.handleClickReject(user)}>
                                <i className="kt-nav__link-icon flaticon2-send"></i>
                                <span className="kt-nav__link-text">Reject</span>
                              </a>
                            </li>
                            
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="kt-portlet__body">

                     
                      <div className="kt-widget kt-widget--user-profile-2">
                        <div className="kt-widget__head">
                          <div className="kt-widget__media">
                            <img className="kt-widget__img kt-hidden-" src="/media/users/default.jpg" alt="image"/>
                            <div className="kt-widget__pic kt-widget__pic--success kt-font-success kt-font-boldest kt-hidden">
                              ChS
                            </div>
                          </div>
                          <div className="kt-widget__info">
                            <a  className="kt-widget__username">
                              {user.firstName} {user.lastName}
                            </a>
                            <span className="kt-widget__desc">
                              {user.businessEntity}
                            </span>
                          </div>
                        </div>
                        <div className="kt-widget__body">
                          <div className="kt-widget__section">
                             {user.registrationNotes}
                          </div>
                          <div className="kt-widget__item">
                            <div className="kt-widget__contact">
                              <span className="kt-widget__label">Business Name:</span>
                              <span className="kt-widget__data">{user.entityName}</span>
                            </div>
                            <div className="kt-widget__contact">
                              <span className="kt-widget__label">Email:</span>
                              <a  className="kt-widget__data">{user.email}</a>
                            </div>
                            <div className="kt-widget__contact">
                              <span className="kt-widget__label">Phone:</span>
                              <a  className="kt-widget__data">{user.mobile}</a>
                            </div>
                            
                          </div>
                        </div>
                        <div className="kt-widget__footer">
                          <button type="button" onClick={() => this.handleClick(user)} className="btn btn-label-warning btn-lg btn-upper">Approve</button>
                        </div>
                      </div>

                      
                    </div>
                  </div>
                </div>
          ))}
        </div>

        {this.state.accountTypes !=null &&
        <Dialog open={this.state.open} onClose={this.handleClose} aria-labelledby="form-dialog-title">
       
        <DialogTitle id="form-dialog-title">Default Account Settings</DialogTitle>
        <DialogContent>


          <TextField  style={{'width':'100%'}} name="accountTypeKey" 
                        id="accountTypeKey" onChange={(e)=> this.setState({accountTypeKey:e.target.value})} label="Account Type"
                         
                          select>
                        {
                         this.state.accountTypes.map((typ) => (
                           <MenuItem key={typ.accountTypeKey} value={typ.accountTypeKey}>{typ.accountTypeName}</MenuItem>
                        ))
                        }
                    </TextField>

                     

                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <Grid container justify="space-around">
                        <KeyboardDatePicker
                              variant="inline"
                              format="MM/dd/yyyy"
                              margin="normal"
                              id="expiryDate"
                              name="expiryDate"
                              label="Expiry Date"
                              value={this.state.expiryDate}
                              onChange={value=>(this.setState({expiryDate:value}))}
                              KeyboardButtonProps={{
                                'aria-label': 'change date',
                              }}
                            />
                        </Grid>
                        </MuiPickersUtilsProvider>

          <Autocomplete
        multiple
        id="tags-standard"
        options={this.state.accounts}
        onChange={this.onSelectTag}

        getOptionLabel={(option) => option.accountName}
        renderInput={(params) => (
                  <TextField
                  {...params}
          
                                            margin="normal"
                                            label="Map Accounts"
                                            
                                          />

        )}
      />
        </DialogContent>
      

        <DialogActions>
          <Button onClick={this.handleClose} color="primary">
            Cancel
          </Button>
        
          <Button onClick={this.approveUser} color="primary">
            Approve
          </Button>
         
        </DialogActions>
         
      </Dialog> 

      }

       
      </>
    );
  }
}

export default injectIntl(UserApproval);

